import Badge from "@mui/material/Badge";
import Chip from "@mui/material/Chip";
import Tabs from "@mui/material/Tabs";
import { colors } from "healthex-common/colors";
import { fontSizes } from "healthex-common/sizes";
import { fontWeights } from "healthex-common/weights";
import styled, { css } from "styled-components";
import { ContentContainer as HXContentContainer, Parent as HXParent, LighterText, mobilePageHPadding, Subtitle, } from "./HXMobilePage.styles";
import { multilineEllipsis } from "./base.styles";
import { FlexColumn, FlexRow } from "./common.styles";
import SearchOff from "@mui/icons-material/SearchOff";
export const Parent = styled(HXParent) `
    margin-top: 0;
`;
export const ContentContainer = styled(HXContentContainer) `
    padding: 0;
    gap: 0;
`;
export const CardContainer = styled(FlexColumn) `
    padding: 16px ${mobilePageHPadding}px;
    gap: 16px;
    border-bottom: 1px solid ${colors.black_4};
`;
export const NoStudiesContentContainer = styled(HXContentContainer) `
    align-items: center;
    text-align: start;
    padding: 44px ${mobilePageHPadding}px 32px ${mobilePageHPadding}px;
`;
export const NoStudiesIcon = styled(SearchOff) `
    width: 40px;
    height: 40px;
    color: ${colors.black_30};
`;
export const ZeroStateTitle = styled.div `
    color: ${colors.black_lighter};
    text-align: center;
    font-size: ${fontSizes.LARGE};
    font-style: normal;
    font-weight: ${fontWeights.SEMI_BOLD};
    line-height: normal;
`;
export const ZeroStateText = styled(LighterText) `
    white-space: pre-wrap;
    text-align: center;
`;
export const PatientListTabs = styled(Tabs) `
    padding: 12px 0;
    border-top: 1px solid ${colors.black_12};
    border-bottom: 1px solid ${colors.black_12};
    position: sticky;
    top: 0;
    z-index: 100;
    background: ${colors.white_background};

    & .MuiTabs-flexContainer {
        gap: 16px;
        padding: 0 ${mobilePageHPadding}px;
    }

    & .MuiTabs-indicator {
        display: none;
    }
`;
export const PatientListTabChip = styled(Chip).attrs({ size: "medium" }) `
    display: flex;
    height: 56px;
    padding: 4px 8px;
    align-items: center;
    border-radius: 100px;
    font-size: ${fontSizes.SMALL};
    font-weight: ${fontWeights.NORMAL};
    line-height: normal;
    letter-spacing: 0.17px;
    background: ${colors.black_8};
    color: ${colors.black_main};

    &:hover {
        background: ${colors.black_8};
        color: ${colors.black_main};
        opacity: 0.95;
    }

    &:active {
        box-shadow: none;
    }

    ${({ isActive }) => isActive &&
    css `
            background: ${colors.navy_main};
            color: ${colors.white_main};
            font-weight: ${fontWeights.SEMI_BOLD};

            &:hover {
                background: ${colors.navy_main};
                color: ${colors.white_main};
            }
        `}
`;
export const PatientListTabChipSpacer = styled(PatientListTabChip) `
    width: 1px;
    height: 1px;
    padding: 0px;
    pointer-events: none;
    opacity: 0;
`;
export const PatientListDate = styled(LighterText) `
    font-size: ${fontSizes.SMALL};
    letter-spacing: 0.17px;
`;
export const PatientListPatientFriendlyTitle = styled(Subtitle) `
    ${multilineEllipsis(1)}
    font-size: ${fontSizes.MEDIUM};
    letter-spacing: 0.17px;
    font-weight: ${({ isBold }) => (isBold ? fontWeights.BOLD : fontWeights.NORMAL)};
    white-space: pre-wrap;
`;
export const PatientListOrgName = styled(LighterText) `
    ${multilineEllipsis(1)}
    font-size: ${fontSizes.SMALL};
    letter-spacing: 0.17px;
    font-weight: ${({ isBold }) => (isBold ? fontWeights.SEMI_BOLD : fontWeights.NORMAL)};
`;
export const PatientListNeedingActionBadge = styled(Badge) `
    background-color: ${colors.accents_sunset};
    width: 8px;
    height: 8px;
    border-radius: 100px;
`;
export const UpdateYourRecords = styled(FlexColumn) `
    padding: 16px;
    border-radius: 12px;
    background-color: ${colors.blue_5};
    justify-content: center;
    align-items: flex-start;
`;
export const PatientListOrgLogoContainer = styled(FlexRow) `
    width: 36px;
    height: 36px;
    align-self: center;
    overflow: hidden;
    border-radius: 6px;
    border: 1px solid ${colors.blue_10};
`;
export const PatientListOrgLogoImg = styled.img.attrs({ width: "100%", height: "100%" }) `
    object-fit: contain;
`;
